var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState, useEffect, useCallback, useRef } from "react";
import { useQuery } from "react-query";
import { Pane, Button, Card, Row, Col, AccordionSet, Accordion, Checkbox, PaneFooter, ErrorModal, Spinner, } from "@folio/stripes/components";
import moment from "moment";
import { useHistory } from "react-router-dom";
import { useOkapiKy } from "@folio/stripes/core";
import { useForm, Controller, useFieldArray, } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { FormattedMessage, useIntl } from "react-intl";
import { createPublisherSchema, createZodErrorMap, } from "../../utils/validationUtils";
import { describeInvalidFields } from "../../utils/validationSummary";
import { isMultipleWorkSpecFormatsError, normalizeWorkSpecification, } from "../../utils/workSpecificationUtils";
import { WorkSpecFormatFields, } from "./WorkSpecFormatFields";
import { checkPublisherDuplicity, createPublisher, fetchAddressCode, fetchGuarantorByEmail, fetchRegions, getDuplicities, lookupPublisherByCompanyNumber, } from "../../api/publisherService";
import { AlternativeNameTypeSelect, RecekTextField, RecekSelect, RecekTextArea, RecekDatepicker, RecekSelection, } from "../../components/inputs";
import DuplicateTable, { useDuplicateTable, DuplicateDetailPane, } from "../../components/DuplicateTable";
import { useAddressSuggest } from "../../hooks/useAddressSuggest";
import { resolveAresLookupErrorMessage } from "../../utils/aresLookupError";
import { RecekPaneSet } from "../../components/RecekPaneSet";
import { AuthorityAuthorRow } from "../../components/AuthorityAuthorRow";
import { searchAuthorityAuthors } from "../../api/authorityAuthorService";
import { personIdsLinkedElsewhere, unlinkedAuthor, } from "../../utils/authorityAuthorUtils";
import { scrollToError, useScrollOnPotentialDuplicates, } from "../../utils/scrollUtils";
import { normalizePublisherGuarantors, resolveGuarantorRole, toggleGuarantorRole, } from "../../utils/guarantorRoles";
import { getServerErrorMessages } from "../../utils/serverErrorUtils";
import { COMPANY_NUMBER_CONFLICT_MESSAGE_ID, getCreateConflictMessageId, } from "../../utils/publisherCreateConflict";
import WarningModal from "../../components/WarningModal";
var PublisherCreate = function () {
    var _a;
    var history = useHistory();
    var ky = useOkapiKy();
    var formatMessage = useIntl().formatMessage;
    var _b = useState([]), potentialDuplicates = _b[0], setPotentialDuplicates = _b[1];
    var _c = useState(""), duplicateWarning = _c[0], setDuplicateWarning = _c[1];
    var _d = useState(false), duplicateModalOpen = _d[0], setDuplicateModalOpen = _d[1];
    // Data awaiting the user's "Continue anyway" confirmation in the duplicate
    // warning; lets us finish the submit directly instead of a fragile 2nd click.
    var duplicateSubmitRef = useRef();
    // Guards the submit against double-clicks / races (disabled + spinner).
    var _e = useState(false), isSubmittingForm = _e[0], setIsSubmittingForm = _e[1];
    var _f = useState(null), icoError = _f[0], setIcoError = _f[1];
    var pendingGuarantorRef = useRef();
    var _g = useState({}), lockedGuarantors = _g[0], setLockedGuarantors = _g[1];
    var publisherSchema = createPublisherSchema(formatMessage);
    var _h = useDuplicateTable(), selectedDuplicatePublisher = _h.selectedDuplicatePublisher, onClose = _h.onClose, setSelectedDuplicatePublisherId = _h.setSelectedDuplicatePublisherId;
    var _j = useState({
        general: true,
        address: true,
        contacts: true,
        alternativeNames: true,
        comments: true,
        guarantors: true,
        workSpecification: true,
    }), accordionStatus = _j[0], setAccordionStatus = _j[1];
    var _k = useForm({
        // Czech messages instead of zod's raw "Required" / "Invalid input" (Tools 75665)
        resolver: zodResolver(publisherSchema, {
            errorMap: createZodErrorMap(formatMessage),
        }),
        shouldFocusError: false,
        defaultValues: {
            registrations: [{ registrationAgency: "", registrationIntent: "" }],
            companyNumber: "",
            name: "",
            nameSuffix: "",
            qualifier: "",
            legalForm: "LEGAL",
            taxNumber: "",
            birthDate: "",
            status: "ACTIVE",
            mainAddress: {
                addressCode: "",
                street: "",
                postalCode: "",
                municipality: "",
                region: { id: "", name: "" },
            },
            mailingAddress: {
                addressCode: "",
                street: "",
                postalCode: "",
                municipality: "",
                region: { id: "", name: "" },
            },
            contacts: [],
            alternativeNames: [],
            internalComment: "",
            guarantors: [
                {
                    id: "",
                    firstName: "",
                    lastName: "",
                    email: "",
                    contacts: [],
                    user: {
                        sourceId: "",
                        firstName: "",
                        lastName: "",
                        email: "",
                        roles: [],
                    },
                    roles: ["PublisherAdmin"],
                },
            ],
            workSpecification: {
                title: "",
                subtitle: "",
                volumeNumber: "",
                partTitle: "",
                authors: [unlinkedAuthor()],
                publicationDate: "",
                editionNumber: "",
                coEditionWith: "",
                publicationForm: "",
                publicationType: {
                    printedPublications: [],
                },
                eBookFormats: [],
                otherFormats: [{ format: "" }],
                dataCarrierVersions: [],
                audioBookFormats: [],
            },
        },
        mode: "onBlur",
    }), handleSubmit = _k.handleSubmit, register = _k.register, control = _k.control, setValue = _k.setValue, getValues = _k.getValues, watch = _k.watch, _l = _k.formState, errors = _l.errors, isSubmitted = _l.isSubmitted, trigger = _k.trigger;
    // the publication form and its refining format are one choice: the component hands over the
    // complete format fields so the payload always carries exactly one format (RECEK-74182)
    var applyWorkSpecFormatFields = function (values) {
        var options = { shouldDirty: true, shouldValidate: isSubmitted };
        setValue("workSpecification.publicationForm", values.publicationForm, options);
        setValue("workSpecification.publicationType.printedPublications", values.publicationType.printedPublications, options);
        setValue("workSpecification.eBookFormats", values.eBookFormats, options);
        setValue("workSpecification.otherFormats", values.otherFormats, options);
        setValue("workSpecification.dataCarrierVersions", values.dataCarrierVersions, options);
        setValue("workSpecification.audioBookFormats", values.audioBookFormats, options);
    };
    var _m = useFieldArray({
        control: control,
        name: "alternativeNames",
    }), alternativeNameFields = _m.fields, appendAlternativeName = _m.append, removeAlternativeNameAtIndex = _m.remove;
    var _o = useFieldArray({
        control: control,
        name: "contacts",
    }), contactFields = _o.fields, appendContact = _o.append, removeContactAtIndex = _o.remove;
    var _p = useFieldArray({
        control: control,
        name: "guarantors",
    }), guarantorFields = _p.fields, appendGuarantor = _p.append, removeGuarantorAtIndex = _p.remove;
    var _q = useFieldArray({
        control: control,
        name: "workSpecification.authors",
    }), authorFields = _q.fields, appendAuthor = _q.append, removeAuthor = _q.remove;
    var watchedAuthors = watch("workSpecification.authors");
    var searchAuthors = useCallback(function (query) { return searchAuthorityAuthors(ky, query); }, [ky]);
    var _r = useFieldArray({
        control: control,
        name: "workSpecification.otherFormats",
    }), otherFormatFields = _r.fields, appendOtherFormat = _r.append, removeOtherFormat = _r.remove;
    var legalFormValue = watch("legalForm");
    var companyNumber = watch("companyNumber");
    var _s = useState(false), confirmOpen = _s[0], setConfirmOpen = _s[1];
    var _t = useState(""), confirmMessage = _t[0], setConfirmMessage = _t[1];
    var enableMainAddress = useState(false)[0];
    var _u = useState(false), enableMailingAddress = _u[0], setEnableMailingAddress = _u[1];
    var _v = useState(""), errorMessage = _v[0], setErrorMessage = _v[1];
    var _w = useState(false), errorModalOpen = _w[0], setErrorModalOpen = _w[1];
    var _x = useState(false), showMailingAddress = _x[0], setShowMailingAddress = _x[1];
    var _y = useState(true), expandAll = _y[0], setExpandAll = _y[1];
    var _z = useState([]), regions = _z[0], setRegions = _z[1];
    // main and mailing address typeaheads share one suggestion list (DB-876: min. 3 characters, 300 ms debounce)
    var addressSuggest = useAddressSuggest(ky);
    var handleAddressSelection = function (selectedValue, type) { return __awaiter(void 0, void 0, void 0, function () {
        var addressDetails, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, fetchAddressCode(ky, selectedValue)];
                case 1:
                    addressDetails = _a.sent();
                    setValue("".concat(type, ".addressCode"), selectedValue, { shouldValidate: true });
                    setValue("".concat(type, ".street"), addressDetails.street, {
                        shouldValidate: true,
                    });
                    setValue("".concat(type, ".postalCode"), addressDetails.postalCode, {
                        shouldValidate: true,
                    });
                    setValue("".concat(type, ".municipality"), addressDetails.municipality, {
                        shouldValidate: true,
                    });
                    setValue("".concat(type, ".region"), addressDetails.region || { id: "", name: "" }, { shouldValidate: true });
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    console.error("Error fetching ".concat(type, " details:"), error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    useQuery("regions", function () { return fetchRegions(ky); }, {
        onSuccess: function (data) {
            setRegions(data);
        },
    });
    var handleInputChange = function (e) {
        var _a = e.target, name = _a.name, value = _a.value;
        if (name in getValues()) {
            setValue(name, value, { shouldValidate: true });
        }
    };
    var _0 = useQuery(["publisher", companyNumber], function () { return lookupPublisherByCompanyNumber(ky, companyNumber !== null && companyNumber !== void 0 ? companyNumber : ""); }, {
        enabled: false,
        retry: false,
        onError: function (error) { return __awaiter(void 0, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        // DB-876: a 429 (ARES rate limiter full) says ARES is overloaded, not a generic error
                        _a = setIcoError;
                        return [4 /*yield*/, resolveAresLookupErrorMessage(error, formatMessage, companyNumber)];
                    case 1:
                        // DB-876: a 429 (ARES rate limiter full) says ARES is overloaded, not a generic error
                        _a.apply(void 0, [_b.sent()]);
                        return [2 /*return*/];
                }
            });
        }); },
    }), isIcoFetching = _0.isFetching, refetchIco = _0.refetch;
    var handleIco = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, icoPublisher, isError, error_2;
        var _b, _c, _d, _e, _f, _g;
        return __generator(this, function (_h) {
            switch (_h.label) {
                case 0:
                    _h.trys.push([0, 4, , 5]);
                    if (!companyNumber || companyNumber.trim() === "") {
                        setIcoError(formatMessage({
                            id: "ui-br-publishers.error.companyNumber.required",
                        }));
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, refetchIco()];
                case 1:
                    _a = _h.sent(), icoPublisher = _a.data, isError = _a.isError;
                    if (isError)
                        return [2 /*return*/];
                    setValue("name", (_b = icoPublisher === null || icoPublisher === void 0 ? void 0 : icoPublisher.name) !== null && _b !== void 0 ? _b : "", { shouldValidate: true });
                    setValue("legalForm", (_c = icoPublisher === null || icoPublisher === void 0 ? void 0 : icoPublisher.legalForm) !== null && _c !== void 0 ? _c : getValues("legalForm"), {
                        shouldValidate: true,
                    });
                    setValue("taxNumber", (_d = icoPublisher === null || icoPublisher === void 0 ? void 0 : icoPublisher.taxNumber) !== null && _d !== void 0 ? _d : getValues("taxNumber"), {
                        shouldValidate: true,
                    });
                    setValue("contacts", (_f = (_e = icoPublisher === null || icoPublisher === void 0 ? void 0 : icoPublisher.contacts) !== null && _e !== void 0 ? _e : getValues("contacts")) !== null && _f !== void 0 ? _f : [], {
                        shouldValidate: true,
                    });
                    if (!((_g = icoPublisher === null || icoPublisher === void 0 ? void 0 : icoPublisher.mainAddress) === null || _g === void 0 ? void 0 : _g.addressCode)) return [3 /*break*/, 3];
                    return [4 /*yield*/, handleAddressSelection(icoPublisher === null || icoPublisher === void 0 ? void 0 : icoPublisher.mainAddress.addressCode, "mainAddress")];
                case 2:
                    _h.sent();
                    _h.label = 3;
                case 3: return [3 /*break*/, 5];
                case 4:
                    error_2 = _h.sent();
                    console.error("Error fetching Ares data:", error_2);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var expandAllSections = function () {
        setAccordionStatus({
            general: true,
            address: true,
            contacts: true,
            alternativeNames: true,
            comments: true,
            guarantors: true,
            workSpecification: true,
        });
        setExpandAll(true);
    };
    var collapseAllSections = function () {
        setAccordionStatus({
            general: false,
            address: false,
            contacts: false,
            alternativeNames: false,
            comments: false,
            guarantors: false,
            workSpecification: false,
        });
        setExpandAll(false);
    };
    var toggleExpandCollapseAll = function () {
        if (expandAll) {
            collapseAllSections();
        }
        else {
            expandAllSections();
        }
    };
    var submitNewPublisher = function (submissionData) { return __awaiter(void 0, void 0, void 0, function () {
        var error_3, status_1, messageId, duplicityMessage, serverMessages;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 7]);
                    return [4 /*yield*/, createPublisher(ky, submissionData)];
                case 1:
                    _b.sent();
                    setDuplicateWarning("");
                    setDuplicateModalOpen(false);
                    history.goBack();
                    return [3 /*break*/, 7];
                case 2:
                    error_3 = _b.sent();
                    status_1 = (_a = error_3 === null || error_3 === void 0 ? void 0 : error_3.response) === null || _a === void 0 ? void 0 : _a.status;
                    if (!(status_1 === 409)) return [3 /*break*/, 4];
                    return [4 /*yield*/, getCreateConflictMessageId(error_3)];
                case 3:
                    messageId = _b.sent();
                    duplicityMessage = formatMessage({ id: messageId });
                    if (messageId === COMPANY_NUMBER_CONFLICT_MESSAGE_ID) {
                        setIcoError(duplicityMessage);
                    }
                    setErrorMessage(duplicityMessage);
                    setErrorModalOpen(true);
                    return [2 /*return*/];
                case 4: return [4 /*yield*/, isMultipleWorkSpecFormatsError(error_3)];
                case 5:
                    if (_b.sent()) {
                        setErrorMessage(formatMessage({
                            id: "ui-br-publishers.error.workSpec.multipleFormats",
                        }));
                        setErrorModalOpen(true);
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, getServerErrorMessages(error_3)];
                case 6:
                    serverMessages = _b.sent();
                    setErrorMessage(formatMessage({ id: "ui-br-publishers.publisherCreate.error.message" }, {
                        error: serverMessages.length > 0
                            ? serverMessages.join(" ")
                            : String(error_3),
                    }));
                    setErrorModalOpen(true);
                    return [3 /*break*/, 7];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    var onSubmit = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var workSpecification, rest, cleanedWorkSpecification, initialData, contacts, guarantors, submissionData, companyNumberValue, isDuplicate, duplicityMessage, error_4, publishers, error_5;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    setIsSubmittingForm(true);
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, , 10, 11]);
                    workSpecification = data.workSpecification, rest = __rest(data, ["workSpecification"]);
                    cleanedWorkSpecification = normalizeWorkSpecification(workSpecification);
                    initialData = __assign(__assign({}, rest), { workSpecification: cleanedWorkSpecification });
                    contacts = (_a = rest === null || rest === void 0 ? void 0 : rest.contacts) === null || _a === void 0 ? void 0 : _a.filter(function (contact) { return contact.type !== "" || contact.value !== ""; });
                    guarantors = ((_b = normalizePublisherGuarantors(rest === null || rest === void 0 ? void 0 : rest.guarantors)) === null || _b === void 0 ? void 0 : _b.map(function (guarantor) {
                        var _a;
                        return (__assign(__assign({}, guarantor), { contacts: ((_a = guarantor.contacts) === null || _a === void 0 ? void 0 : _a.filter(function (contact) { var _a, _b; return ((_a = contact.type) === null || _a === void 0 ? void 0 : _a.trim()) !== "" && ((_b = contact.value) === null || _b === void 0 ? void 0 : _b.trim()) !== ""; })) || [] }));
                    })) || [];
                    submissionData = __assign(__assign({}, initialData), { contacts: contacts, guarantors: guarantors });
                    companyNumberValue = (_c = submissionData.companyNumber) === null || _c === void 0 ? void 0 : _c.trim();
                    if (!companyNumberValue) return [3 /*break*/, 5];
                    _d.label = 2;
                case 2:
                    _d.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, checkPublisherDuplicity(ky, companyNumberValue)];
                case 3:
                    isDuplicate = (_d.sent()).isDuplicate;
                    if (isDuplicate) {
                        duplicityMessage = formatMessage({
                            id: "ui-br-publishers.error.companyNumberAlreadyRegistered",
                        });
                        setIcoError(duplicityMessage);
                        setErrorMessage(duplicityMessage);
                        setErrorModalOpen(true);
                        return [2 /*return*/];
                    }
                    return [3 /*break*/, 5];
                case 4:
                    error_4 = _d.sent();
                    console.error("Error checking company number duplicity:", error_4);
                    return [3 /*break*/, 5];
                case 5:
                    _d.trys.push([5, 7, , 8]);
                    return [4 /*yield*/, getDuplicities(ky, submissionData)];
                case 6:
                    publishers = (_d.sent()).publishers;
                    if (publishers && publishers.length > 0) {
                        setPotentialDuplicates(publishers);
                        setDuplicateWarning(formatMessage({
                            id: "ui-br-publishers.publisher.warning.message.duplicatesFound.save",
                        }));
                        duplicateSubmitRef.current = submissionData;
                        setDuplicateModalOpen(true);
                        return [2 /*return*/];
                    }
                    return [3 /*break*/, 8];
                case 7:
                    error_5 = _d.sent();
                    console.error("Error checking duplicities:", error_5);
                    return [3 /*break*/, 8];
                case 8: return [4 /*yield*/, submitNewPublisher(submissionData)];
                case 9:
                    _d.sent();
                    return [3 /*break*/, 11];
                case 10:
                    setIsSubmittingForm(false);
                    return [7 /*endfinally*/];
                case 11: return [2 /*return*/];
            }
        });
    }); };
    // Duplicate warning confirmed ("Přesto pokračovat") → finish the submit
    // directly instead of relying on a fragile isEqual + repeated-click path.
    var handleDuplicateConfirm = function () { return __awaiter(void 0, void 0, void 0, function () {
        var pending;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    pending = duplicateSubmitRef.current;
                    duplicateSubmitRef.current = undefined;
                    setDuplicateModalOpen(false);
                    if (!pending)
                        return [2 /*return*/];
                    setIsSubmittingForm(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, submitNewPublisher(pending)];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    setIsSubmittingForm(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleDuplicateCancel = function () {
        duplicateSubmitRef.current = undefined;
        setDuplicateModalOpen(false);
    };
    var sectionForFieldPath = function (path) {
        var top = path.split(".")[0];
        switch (top) {
            case "registrations":
            case "companyNumber":
            case "name":
            case "nameSuffix":
            case "qualifier":
            case "legalForm":
            case "taxNumber":
            case "birthDate":
            case "status":
                return "general";
            case "mainAddress":
            case "mailingAddress":
                return "address";
            case "contacts":
                return "contacts";
            case "alternativeNames":
                return "alternativeNames";
            case "internalComment":
                return "comments";
            case "guarantors":
                return "guarantors";
            case "workSpecification":
                return "workSpecification";
            default:
                return null;
        }
    };
    /**
     * Makes an invalid mailing address field fixable: shows the mailing address
     * and turns its editing on, keeping the entered values (unlike the checkbox,
     * which clears the address when editing is turned on). The main address is
     * filled from RÚIAN only, so its errors are left to the validation summary.
     */
    var unlockAddressForField = function (path) {
        var _a = path.split("."), address = _a[0], field = _a[1];
        if (address === "mailingAddress" && field !== "addressCode") {
            setShowMailingAddress(true);
            setEnableMailingAddress(true);
        }
    };
    // Expand the accordion that holds the offending field so scrollToError can
    // reach it (fields inside a collapsed section are otherwise unreachable).
    var openSectionForField = function (path) {
        var section = sectionForFieldPath(path);
        if (section) {
            setAccordionStatus(function (prev) {
                var _a;
                return (__assign(__assign({}, prev), (_a = {}, _a[section] = true, _a)));
            });
        }
        unlockAddressForField(path);
    };
    // Last-resort visible feedback when no invalid input can be focused, so the
    // submit never fails silently.
    var showValidationSummary = function (invalidFields) {
        // every entry names its section and field in Czech (Tools 75665)
        var fields = describeInvalidFields(invalidFields, formatMessage, getValues()).join(" • ");
        setErrorMessage(formatMessage({ id: "ui-br-publishers.validation.summary.message" }, { fields: fields }));
        setErrorModalOpen(true);
    };
    var handleWarningConfirm = useCallback(function () {
        var _a, _b;
        setConfirmOpen(false);
        var _c = pendingGuarantorRef.current, index = _c.index, guarantor = _c.guarantor;
        setValue("guarantors.".concat(index, ".firstName"), guarantor.firstName);
        setValue("guarantors.".concat(index, ".lastName"), guarantor.lastName);
        setValue("guarantors.".concat(index, ".titlesBefore"), (_a = guarantor.titlesBefore) !== null && _a !== void 0 ? _a : "");
        setValue("guarantors.".concat(index, ".titlesAfter"), (_b = guarantor.titlesAfter) !== null && _b !== void 0 ? _b : "");
        setLockedGuarantors(function (m) {
            var _a;
            return (__assign(__assign({}, m), (_a = {}, _a[index] = true, _a)));
        });
        pendingGuarantorRef.current = undefined;
    }, [setValue, setLockedGuarantors]);
    var handleWarningCancel = useCallback(function () {
        setConfirmOpen(false);
        if (pendingGuarantorRef.current) {
            var index = pendingGuarantorRef.current.index;
            setValue("guarantors.".concat(index, ".email"), "");
            pendingGuarantorRef.current = undefined;
        }
    }, [setValue]);
    var handleGuarantorEmailBlur = function (index) { return __awaiter(void 0, void 0, void 0, function () {
        var email, guarantor, error_6;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    email = getValues("guarantors.".concat(index, ".email"));
                    if (!email)
                        return [2 /*return*/];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, fetchGuarantorByEmail(ky, email)];
                case 2:
                    guarantor = _a.sent();
                    pendingGuarantorRef.current = { index: index, guarantor: guarantor };
                    setConfirmMessage(formatMessage({ id: "ui-br-publishers.error.guarantorDuplicity" }, {
                        firstName: guarantor.firstName,
                        lastName: guarantor.lastName,
                    }));
                    setConfirmOpen(true);
                    return [3 /*break*/, 4];
                case 3:
                    error_6 = _a.sent();
                    console.error("Failed to fetch guarantor by email (\u201C".concat(email, "\u201D):"), error_6);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var unlockGuarantor = useCallback(function (index) {
        setLockedGuarantors(function (prev) {
            var rest = __assign({}, prev);
            delete rest[index];
            return rest;
        });
    }, []);
    var topRef = useScrollOnPotentialDuplicates(potentialDuplicates).topRef;
    useEffect(function () {
        if (Object.keys(errors).length > 0) {
            scrollToError(errors, { openSectionForField: openSectionForField });
        }
    }, [errors]);
    var handleValidationErrors = function (validationErrors) {
        scrollToError(validationErrors, {
            openSectionForField: openSectionForField,
            onUnresolvedErrors: showValidationSummary,
        });
    };
    return (React.createElement(RecekPaneSet, null,
        React.createElement(Pane, { id: "contentPane", defaultWidth: "fill", paneTitle: formatMessage({
                id: "ui-br-publishers.publishers.create.pane.title",
            }), footer: React.createElement(PaneFooter, { renderStart: React.createElement(Button, { buttonStyle: "primary", onClick: handleSubmit(onSubmit, handleValidationErrors), disabled: isSubmittingForm }, isSubmittingForm ? (React.createElement(Spinner, null)) : (React.createElement(FormattedMessage, { id: "ui-br-publishers.button.save" }))), renderEnd: React.createElement(Button, { buttonStyle: "default", onClick: function () { return history.goBack(); } },
                    React.createElement(FormattedMessage, { id: "ui-br-publishers.button.cancel" })) }) },
            React.createElement(ErrorModal, { open: errorModalOpen, label: formatMessage({
                    id: "ui-br-publishers.error.modal.title",
                }), content: errorMessage, onClose: function () { return setErrorModalOpen(false); } },
                React.createElement("div", null, errorMessage),
                React.createElement(Button, { onClick: function () { return setErrorModalOpen(false); } },
                    React.createElement(FormattedMessage, { id: "ui-br-publishers.button.close" }))),
            React.createElement(WarningModal, { open: confirmOpen, mode: "continue", message: confirmMessage, onConfirm: handleWarningConfirm, onCancel: handleWarningCancel }),
            React.createElement(WarningModal, { open: duplicateModalOpen, mode: "continue", message: duplicateWarning, confirmLabel: formatMessage({
                    id: "ui-br-publishers.button.continueAnyway",
                }), onConfirm: handleDuplicateConfirm, onCancel: handleDuplicateCancel }),
            React.createElement(Row, null,
                React.createElement(Col, { xs: 12, style: { display: "flex", justifyContent: "flex-end" } },
                    React.createElement(Button, { onClick: toggleExpandCollapseAll, buttonStyle: "default" }, expandAll ? (React.createElement(FormattedMessage, { id: "ui-br-publishers.button.collapse.all" })) : (React.createElement(FormattedMessage, { id: "ui-br-publishers.button.expand.all" }))))),
            React.createElement("form", { onSubmit: handleSubmit(onSubmit, handleValidationErrors) },
                React.createElement(AccordionSet, null,
                    React.createElement("div", { ref: topRef }),
                    (potentialDuplicates === null || potentialDuplicates === void 0 ? void 0 : potentialDuplicates.length) > 0 ? (React.createElement(Accordion, { id: "duplicates-table", label: formatMessage({
                            id: "ui-br-publishers.publishers.accordion.label.potentialDuplicates",
                        }) },
                        duplicateWarning && (React.createElement("div", { style: { color: "red", marginBottom: "1rem" } }, duplicateWarning)),
                        React.createElement(DuplicateTable, { duplicates: potentialDuplicates, onDuplicateClick: setSelectedDuplicatePublisherId }))) : null,
                    React.createElement(Accordion, { label: formatMessage({
                            id: "ui-br-publishers.publishers.accordion.label.general",
                        }), open: accordionStatus.general, onToggle: function () {
                            return setAccordionStatus(__assign(__assign({}, accordionStatus), { general: !accordionStatus.general }));
                        } },
                        React.createElement(Row, null,
                            React.createElement(Col, { xs: 6 },
                                React.createElement(Controller, { control: control, name: "registrations.0.registrationAgency", render: function (_a) {
                                        var _b, _c, _d;
                                        var field = _a.field;
                                        return (React.createElement(RecekSelect, __assign({}, field, { autoComplete: "off", labelId: "ui-br-publishers.publishers.label.select.registration.agency", required: true, error: (_d = (_c = (_b = errors.registrations) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.registrationAgency) === null || _d === void 0 ? void 0 : _d.message, dataOptions: [
                                                {
                                                    value: "",
                                                    label: formatMessage({
                                                        id: "ui-br-publishers.publishers.label.registration.agency.default",
                                                    }),
                                                },
                                                {
                                                    value: "ISBN",
                                                    label: formatMessage({
                                                        id: "ui-br-publishers.publishers.label.registration.agency.ISBN",
                                                    }),
                                                },
                                                {
                                                    value: "ISMN",
                                                    label: formatMessage({
                                                        id: "ui-br-publishers.publishers.label.registration.agency.ISMN",
                                                    }),
                                                },
                                            ] })));
                                    } })),
                            React.createElement(Col, { xs: 6 },
                                React.createElement(Controller, { control: control, name: "registrations.0.registrationIntent", render: function (_a) {
                                        var _b, _c, _d;
                                        var field = _a.field;
                                        return (React.createElement(RecekSelect, __assign({}, field, { autoComplete: "off", labelId: "ui-br-publishers.publishers.label.select.registration.intent", required: true, error: (_d = (_c = (_b = errors.registrations) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.registrationIntent) === null || _d === void 0 ? void 0 : _d.message, dataOptions: [
                                                {
                                                    value: "",
                                                    label: formatMessage({
                                                        id: "ui-br-publishers.publishers.label.registration.intent.default",
                                                    }),
                                                },
                                                {
                                                    value: "CONTINUOUS",
                                                    label: formatMessage({
                                                        id: "ui-br-publishers.publishers.label.registration.intent.CONTINUOUS",
                                                    }),
                                                },
                                                {
                                                    value: "ONE_OFF",
                                                    label: formatMessage({
                                                        id: "ui-br-publishers.publishers.label.registration.intent.ONE_OFF",
                                                    }),
                                                },
                                            ] })));
                                    } })),
                            React.createElement(Col, { xs: 6, style: {
                                    display: "flex",
                                    alignItems: Boolean((_a = errors.companyNumber) === null || _a === void 0 ? void 0 : _a.message) || icoError
                                        ? "center"
                                        : "flex-end",
                                } },
                                React.createElement(Controller, { control: control, name: "companyNumber", render: function (_a) {
                                        var _b, _c;
                                        var field = _a.field;
                                        return (React.createElement(React.Fragment, null,
                                            React.createElement(RecekTextField, __assign({}, field, { autoComplete: "off", labelId: "ui-br-publishers.publishers.general.field.label.companyNumber", required: true, error: (_c = (_b = errors.companyNumber) === null || _b === void 0 ? void 0 : _b.message) !== null && _c !== void 0 ? _c : icoError, onBlur: function () {
                                                    field.onBlur();
                                                    trigger([
                                                        "companyNumber",
                                                        "taxNumber",
                                                        "birthDate",
                                                    ]);
                                                }, onChange: function (e) {
                                                    field.onChange(e);
                                                    setIcoError(null);
                                                }, onKeyDown: function (e) {
                                                    if (e.key === "Enter") {
                                                        e.preventDefault();
                                                        handleIco();
                                                    }
                                                } })),
                                            React.createElement(Button, { buttonStyle: "primary", onClick: handleIco, disabled: isIcoFetching, style: {
                                                    marginLeft: "16px",
                                                    marginBottom: "1rem",
                                                } }, isIcoFetching ? (React.createElement(Spinner, null)) : (React.createElement(FormattedMessage, { id: "ui-br-publishers.publishers.general.button.companyNumber" })))));
                                    } })),
                            React.createElement(Col, { xs: 6 },
                                React.createElement(Controller, { control: control, name: "legalForm", render: function (_a) {
                                        var field = _a.field;
                                        return (React.createElement(RecekSelect, __assign({}, field, { autoComplete: "off", onChange: function (e) {
                                                field.onChange(e);
                                                trigger(["companyNumber", "taxNumber", "birthDate"]);
                                            }, labelId: "ui-br-publishers.publishers.general.select.label.legalForm" }),
                                            React.createElement("option", { value: "UNKNOWN" }, formatMessage({
                                                id: "ui-br-publishers.publishers.general.select.legal.form.unknown",
                                            })),
                                            React.createElement("option", { value: "LEGAL" }, formatMessage({
                                                id: "ui-br-publishers.publishers.general.select.label.legal",
                                            })),
                                            React.createElement("option", { value: "NATURAL" }, formatMessage({
                                                id: "ui-br-publishers.publishers.general.select.label.natural",
                                            }))));
                                    } }))),
                        React.createElement(Row, null,
                            React.createElement(Col, { xs: 6 },
                                React.createElement(Controller, { control: control, name: "name", render: function (_a) {
                                        var _b;
                                        var field = _a.field;
                                        return (React.createElement(RecekTextField, __assign({ labelId: legalFormValue === "LEGAL"
                                                ? "ui-br-publishers.publishers.general.field.label.name.legal"
                                                : "ui-br-publishers.publishers.general.field.label.name.natural" }, field, { autoComplete: "off", required: true, error: (_b = errors.name) === null || _b === void 0 ? void 0 : _b.message })));
                                    } })),
                            React.createElement(Col, { xs: 6 },
                                React.createElement(Controller, { control: control, name: "nameSuffix", render: function (_a) {
                                        var field = _a.field;
                                        return (React.createElement(RecekTextField, __assign({ labelId: "ui-br-publishers.publishers.general.field.label.nameSuffix" }, field, { autoComplete: "off" })));
                                    } }))),
                        React.createElement(Row, null,
                            React.createElement(Col, { xs: 6 },
                                React.createElement(Controller, { control: control, name: "taxNumber", render: function (_a) {
                                        var _b;
                                        var field = _a.field;
                                        return (React.createElement(RecekTextField, __assign({ labelId: "ui-br-publishers.publishers.general.field.label.taxNumber" }, field, { autoComplete: "off", required: true, error: (_b = errors.taxNumber) === null || _b === void 0 ? void 0 : _b.message, onBlur: function () {
                                                field.onBlur();
                                                trigger(["companyNumber", "taxNumber", "birthDate"]);
                                            } })));
                                    } })),
                            legalFormValue === "NATURAL" && (React.createElement(Col, { xs: 6 },
                                React.createElement(Controller, { control: control, name: "birthDate", render: function (_a) {
                                        var _b;
                                        var field = _a.field;
                                        return (React.createElement(RecekDatepicker, __assign({ labelId: "ui-br-publishers.publishers.general.datePicker.label.birthDate" }, field, { autoComplete: "off", error: (_b = errors.birthDate) === null || _b === void 0 ? void 0 : _b.message, exclude: function (day) {
                                                return day.isAfter(moment());
                                            }, backendDateStandard: "YYYY-MM-DD", dateFormat: "DD/MM/YYYY", placeholder: "DD/MM/RRRR", onBlur: function () {
                                                field.onBlur();
                                                trigger([
                                                    "companyNumber",
                                                    "taxNumber",
                                                    "birthDate",
                                                ]);
                                            } })));
                                    } }))))),
                    React.createElement(Accordion, { label: formatMessage({
                            id: "ui-br-publishers.publishers.accordion.label.address",
                        }), open: accordionStatus.address, onToggle: function () {
                            return setAccordionStatus(__assign(__assign({}, accordionStatus), { address: !accordionStatus.address }));
                        } },
                        React.createElement(Row, null,
                            React.createElement(Col, { xs: 6 },
                                React.createElement(Controller, { control: control, name: "mainAddress.addressCode", render: function (_a) {
                                        var field = _a.field;
                                        return (React.createElement(RecekSelection, __assign({}, field, { autoComplete: "off", labelId: "ui-br-publishers.publishers.mainAddress.selection.label.addressCode", asyncFilter: true, onFilter: addressSuggest.onFilter, loading: addressSuggest.loading, loadingMessage: React.createElement(FormattedMessage, { id: "ui-br-publishers.address.suggest.loading" }), emptyMessage: React.createElement(FormattedMessage, { id: addressSuggest.emptyMessageId }), dataOptions: addressSuggest.addresses.map(function (address) { return ({
                                                value: address.addressCode,
                                                label: address.address,
                                            }); }), onChange: function (selectedValue) {
                                                field.onChange(selectedValue);
                                                handleAddressSelection(selectedValue, "mainAddress");
                                            } })));
                                    } })),
                            React.createElement(Col, { xs: 6 },
                                React.createElement(Controller, { control: control, name: "mainAddress.region.id", render: function (_a) {
                                        var _b, _c, _d, _e, _f, _g;
                                        var field = _a.field;
                                        return (React.createElement(RecekSelect, __assign({}, field, { autoComplete: "off", labelId: "ui-br-publishers.publishers.mainAddress.select.label.region", required: true, error: (_e = (_d = (_c = (_b = errors.mainAddress) === null || _b === void 0 ? void 0 : _b.region) === null || _c === void 0 ? void 0 : _c.id) === null || _d === void 0 ? void 0 : _d.message) !== null && _e !== void 0 ? _e : (_g = (_f = errors.mainAddress) === null || _f === void 0 ? void 0 : _f.region) === null || _g === void 0 ? void 0 : _g.message, disabled: !enableMainAddress, dataOptions: __spreadArray([
                                                {
                                                    value: "",
                                                    label: formatMessage({
                                                        id: "ui-br-publishers.publishers.mainAddress.select.label.default",
                                                    }),
                                                }
                                            ], regions.map(function (region) { return ({
                                                value: region.id,
                                                label: region.name,
                                            }); }), true), onChange: function (e) {
                                                var selectedRegion = regions.find(function (region) { return region.id === e.target.value; });
                                                setValue("mainAddress.region", selectedRegion || { id: "", name: "" });
                                            } })));
                                    } })),
                            React.createElement(Col, { xs: 6 },
                                React.createElement(Controller, { control: control, name: "mainAddress.street", render: function (_a) {
                                        var _b, _c;
                                        var field = _a.field;
                                        return (React.createElement(RecekTextField, __assign({}, field, { autoComplete: "off", labelId: "ui-br-publishers.publishers.mainAddress.field.label.street", error: (_c = (_b = errors.mainAddress) === null || _b === void 0 ? void 0 : _b.street) === null || _c === void 0 ? void 0 : _c.message, disabled: !enableMainAddress })));
                                    } })),
                            React.createElement(Col, { xs: 6 },
                                React.createElement(Controller, { control: control, name: "mainAddress.postalCode", render: function (_a) {
                                        var _b, _c;
                                        var field = _a.field;
                                        return (React.createElement(RecekTextField, __assign({}, field, { autoComplete: "off", labelId: "ui-br-publishers.publishers.general.field.label.postalCode", error: (_c = (_b = errors.mainAddress) === null || _b === void 0 ? void 0 : _b.postalCode) === null || _c === void 0 ? void 0 : _c.message, disabled: !enableMainAddress })));
                                    } })),
                            React.createElement(Col, { xs: 6 },
                                React.createElement(Controller, { control: control, name: "mainAddress.municipality", render: function (_a) {
                                        var _b, _c;
                                        var field = _a.field;
                                        return (React.createElement(RecekTextField, __assign({}, field, { autoComplete: "off", labelId: "ui-br-publishers.publishers.general.field.label.municipality", error: (_c = (_b = errors.mainAddress) === null || _b === void 0 ? void 0 : _b.municipality) === null || _c === void 0 ? void 0 : _c.message, disabled: !enableMainAddress })));
                                    } }))),
                        React.createElement(Checkbox, { label: formatMessage({
                                id: "ui-br-publishers.publishers.mailingAddress.checkbox.label.show",
                            }), checked: showMailingAddress, onChange: function () { return setShowMailingAddress(!showMailingAddress); } }),
                        showMailingAddress && (React.createElement(React.Fragment, null,
                            React.createElement(Row, null,
                                React.createElement(Col, { xs: 6 },
                                    React.createElement(Controller, { control: control, name: "mailingAddress.addressCode", render: function (_a) {
                                            var field = _a.field;
                                            return (React.createElement(RecekSelection, __assign({}, field, { autoComplete: "off", labelId: "ui-br-publishers.publishers.mailingAddress.selection.label.addressCode", asyncFilter: true, onFilter: addressSuggest.onFilter, loading: addressSuggest.loading, loadingMessage: React.createElement(FormattedMessage, { id: "ui-br-publishers.address.suggest.loading" }), emptyMessage: React.createElement(FormattedMessage, { id: addressSuggest.emptyMessageId }), dataOptions: addressSuggest.addresses.map(function (address) { return ({
                                                    value: address.addressCode,
                                                    label: address.address,
                                                }); }), onChange: function (selectedValue) {
                                                    field.onChange(selectedValue);
                                                    handleAddressSelection(selectedValue, "mailingAddress");
                                                } })));
                                        } })),
                                React.createElement(Col, { xs: 6, style: { display: "flex", alignItems: "center" } },
                                    React.createElement(Checkbox, { label: formatMessage({
                                            id: "ui-br-publishers.publishers.mailingAddress.checkbox.label.address",
                                        }), checked: enableMailingAddress, onChange: function () {
                                            setEnableMailingAddress(!enableMailingAddress);
                                            if (!enableMailingAddress) {
                                                setValue("mailingAddress.addressCode", "");
                                                setValue("mailingAddress.street", "");
                                                setValue("mailingAddress.postalCode", "");
                                                setValue("mailingAddress.municipality", "");
                                                setValue("mailingAddress.region", {
                                                    id: "",
                                                    name: "",
                                                });
                                            }
                                        } })),
                                React.createElement(Col, { xs: 6 },
                                    React.createElement(Controller, { control: control, name: "mailingAddress.region.id", render: function (_a) {
                                            var _b, _c, _d, _e, _f, _g;
                                            var field = _a.field;
                                            return (React.createElement(RecekSelect, __assign({}, field, { autoComplete: "off", labelId: "ui-br-publishers.publishers.mailingAddress.select.label.region", error: (_e = (_d = (_c = (_b = errors.mailingAddress) === null || _b === void 0 ? void 0 : _b.region) === null || _c === void 0 ? void 0 : _c.id) === null || _d === void 0 ? void 0 : _d.message) !== null && _e !== void 0 ? _e : (_g = (_f = errors.mailingAddress) === null || _f === void 0 ? void 0 : _f.region) === null || _g === void 0 ? void 0 : _g.message, disabled: !enableMailingAddress, dataOptions: __spreadArray([
                                                    {
                                                        value: "",
                                                        label: formatMessage({
                                                            id: "ui-br-publishers.publishers.mailingAddress.select.label.default",
                                                        }),
                                                    }
                                                ], regions.map(function (region) { return ({
                                                    value: region.id,
                                                    label: region.name,
                                                }); }), true), onChange: function (e) {
                                                    var selectedRegion = regions.find(function (region) { return region.id === e.target.value; });
                                                    setValue("mailingAddress.region", selectedRegion || { id: "", name: "" });
                                                } })));
                                        } })),
                                React.createElement(Col, { xs: 6 },
                                    React.createElement(Controller, { control: control, name: "mailingAddress.street", render: function (_a) {
                                            var _b, _c;
                                            var field = _a.field;
                                            return (React.createElement(RecekTextField, __assign({}, field, { autoComplete: "off", labelId: "ui-br-publishers.publishers.mailingAddress.field.label.street", error: (_c = (_b = errors.mailingAddress) === null || _b === void 0 ? void 0 : _b.street) === null || _c === void 0 ? void 0 : _c.message, disabled: !enableMailingAddress })));
                                        } })),
                                React.createElement(Col, { xs: 6 },
                                    React.createElement(Controller, { control: control, name: "mailingAddress.postalCode", render: function (_a) {
                                            var _b, _c;
                                            var field = _a.field;
                                            return (React.createElement(RecekTextField, __assign({}, field, { autoComplete: "off", labelId: "ui-br-publishers.publishers.general.field.label.postalCode", error: (_c = (_b = errors.mailingAddress) === null || _b === void 0 ? void 0 : _b.postalCode) === null || _c === void 0 ? void 0 : _c.message, disabled: !enableMailingAddress })));
                                        } })),
                                React.createElement(Col, { xs: 6 },
                                    React.createElement(Controller, { control: control, name: "mailingAddress.municipality", render: function (_a) {
                                            var _b, _c;
                                            var field = _a.field;
                                            return (React.createElement(RecekTextField, __assign({}, field, { autoComplete: "off", labelId: "ui-br-publishers.publishers.general.field.label.municipality", error: (_c = (_b = errors.mailingAddress) === null || _b === void 0 ? void 0 : _b.municipality) === null || _c === void 0 ? void 0 : _c.message, disabled: !enableMailingAddress })));
                                        } })))))),
                    React.createElement(Accordion, { label: formatMessage({
                            id: "ui-br-publishers.publishers.accordion.label.contacts",
                        }), open: accordionStatus.contacts, onToggle: function () {
                            return setAccordionStatus(__assign(__assign({}, accordionStatus), { contacts: !accordionStatus.contacts }));
                        } },
                        contactFields.map(function (field, index) { return (React.createElement(Row, { key: field.id },
                            React.createElement(Col, { xs: 4 },
                                React.createElement(Controller, { control: control, name: "contacts.".concat(index, ".type"), render: function (_a) {
                                        var _b, _c, _d, _e, _f;
                                        var field = _a.field;
                                        return (React.createElement(RecekSelect, __assign({}, field, { autoComplete: "off", labelId: "ui-br-publishers.publishers.contacts.select.label.type", error: typeof ((_c = (_b = errors.contacts) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.type) === "object"
                                                ? (_f = (_e = (_d = errors.contacts) === null || _d === void 0 ? void 0 : _d[index]) === null || _e === void 0 ? void 0 : _e.type) === null || _f === void 0 ? void 0 : _f.message
                                                : undefined, dataOptions: [
                                                {
                                                    value: "",
                                                    label: formatMessage({
                                                        id: "ui-br-publishers.publishers.contacts.select.label.default",
                                                    }),
                                                },
                                                {
                                                    value: "EMAIL",
                                                    label: formatMessage({
                                                        id: "ui-br-publishers.publishers.contacts.select.label.email",
                                                    }),
                                                },
                                                {
                                                    value: "WEB",
                                                    label: formatMessage({
                                                        id: "ui-br-publishers.publishers.contacts.select.label.web",
                                                    }),
                                                },
                                                {
                                                    value: "PHONE",
                                                    label: formatMessage({
                                                        id: "ui-br-publishers.publishers.contacts.select.label.phone",
                                                    }),
                                                },
                                                {
                                                    value: "DATA_BOX",
                                                    label: formatMessage({
                                                        id: "ui-br-publishers.publishers.contacts.select.label.dataBox",
                                                    }),
                                                },
                                            ] })));
                                    } })),
                            React.createElement(Col, { xs: 4 },
                                React.createElement(Controller, { control: control, name: "contacts.".concat(index, ".value"), render: function (_a) {
                                        var _b, _c, _d;
                                        var field = _a.field;
                                        return (React.createElement(RecekTextField, __assign({}, field, { autoComplete: "off", labelId: "ui-br-publishers.publishers.contacts.field.label.contact", error: (_d = (_c = (_b = errors.contacts) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.value) === null || _d === void 0 ? void 0 : _d.message })));
                                    } })),
                            React.createElement(Col, { xs: 4 },
                                React.createElement(Controller, { control: control, name: "contacts.".concat(index, ".info"), render: function (_a) {
                                        var field = _a.field;
                                        return (React.createElement(RecekTextField, __assign({}, field, { autoComplete: "off", labelId: "ui-br-publishers.publishers.contacts.field.label.info" })));
                                    } })),
                            React.createElement(Col, { xs: 2 },
                                React.createElement(Button, { buttonStyle: "danger", onClick: function () { return removeContactAtIndex(index); }, style: { marginTop: "25px" } },
                                    React.createElement(FormattedMessage, { id: "ui-br-publishers.publishers.contacts.button.delete" }))))); }),
                        React.createElement(Button, { onClick: function () {
                                return appendContact({
                                    type: "",
                                    value: "",
                                    info: "",
                                }, { shouldFocus: false });
                            } },
                            React.createElement(FormattedMessage, { id: "ui-br-publishers.publishers.contacts.button.add" }))),
                    React.createElement(Accordion, { label: formatMessage({
                            id: "ui-br-publishers.publishers.accordion.label.alternativeNames",
                        }), open: accordionStatus.alternativeNames, onToggle: function () {
                            return setAccordionStatus(__assign(__assign({}, accordionStatus), { alternativeNames: !accordionStatus.alternativeNames }));
                        } },
                        alternativeNameFields.map(function (field, index) { return (React.createElement(Row, { key: field.id },
                            React.createElement(Col, { xs: 4 },
                                React.createElement(Controller, { control: control, name: "alternativeNames.".concat(index, ".name"), defaultValue: field.name, render: function (_a) {
                                        var _b, _c, _d;
                                        var field = _a.field;
                                        return (React.createElement(RecekTextField, __assign({}, field, { autoComplete: "off", labelId: "ui-br-publishers.publishers.alternativeNames.field.label.name", required: true, error: (_d = (_c = (_b = errors.alternativeNames) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.name) === null || _d === void 0 ? void 0 : _d.message })));
                                    } })),
                            React.createElement(Col, { xs: 4 },
                                React.createElement(Controller, { control: control, name: "alternativeNames.".concat(index, ".nameSuffix"), defaultValue: field.nameSuffix, render: function (_a) {
                                        var _b, _c, _d;
                                        var field = _a.field;
                                        return (React.createElement(RecekTextField, __assign({}, field, { autoComplete: "off", labelId: "ui-br-publishers.publishers.alternativeNames.field.label.nameSuffix", error: (_d = (_c = (_b = errors.alternativeNames) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.nameSuffix) === null || _d === void 0 ? void 0 : _d.message })));
                                    } })),
                            React.createElement(Col, { xs: 4 },
                                React.createElement(Controller, { control: control, name: "alternativeNames.".concat(index, ".qualifier"), defaultValue: field.qualifier, render: function (_a) {
                                        var _b, _c, _d;
                                        var field = _a.field;
                                        return (React.createElement(RecekTextField, __assign({}, field, { autoComplete: "off", labelId: "ui-br-publishers.publishers.general.field.label.qualifier", error: (_d = (_c = (_b = errors.alternativeNames) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.qualifier) === null || _d === void 0 ? void 0 : _d.message })));
                                    } })),
                            React.createElement(Col, { xs: 4 },
                                React.createElement(AlternativeNameTypeSelect, { control: control, name: "alternativeNames.".concat(index, ".type"), autoComplete: "off" })),
                            React.createElement(Col, { xs: 2 },
                                React.createElement(Controller, { control: control, name: "alternativeNames.".concat(index, ".nonPublic"), defaultValue: field.nonPublic, render: function (_a) {
                                        var field = _a.field;
                                        return (React.createElement(Checkbox, { checked: field.value, onChange: function (e) { return field.onChange(e.target.checked); }, label: formatMessage({
                                                id: "ui-br-publishers.publishers.alternativeNames.checkbox.label.nonPublic",
                                            }) }));
                                    } })),
                            React.createElement(Col, { xs: 12 },
                                React.createElement(Button, { buttonStyle: "danger", onClick: function () { return removeAlternativeNameAtIndex(index); }, style: { marginTop: "10px" } },
                                    React.createElement(FormattedMessage, { id: "ui-br-publishers.publishers.alternativeNames.button.delete" }))))); }),
                        React.createElement(Button, { onClick: function () {
                                return appendAlternativeName({
                                    name: "",
                                    nameSuffix: "",
                                    qualifier: "",
                                    type: undefined,
                                    nonPublic: false,
                                }, { shouldFocus: false });
                            } },
                            React.createElement(FormattedMessage, { id: "ui-br-publishers.publishers.alternativeNames.button.add" }))),
                    React.createElement(Accordion, { label: formatMessage({
                            id: "ui-br-publishers.publishers.accordion.label.guarantors",
                        }), id: "guarantors", open: accordionStatus.guarantors, onToggle: function () {
                            return setAccordionStatus(__assign(__assign({}, accordionStatus), { guarantors: !accordionStatus.guarantors }));
                        } },
                        React.createElement(Row, null,
                            React.createElement(Col, { xs: 12 },
                                guarantorFields.map(function (guarantor, index) {
                                    var _a;
                                    return (React.createElement(Card, { key: guarantor.id, headerStart: React.createElement(FormattedMessage, { id: "ui-br-publishers.publishers.guarantors.card.header" }), roundedBorder: true },
                                        React.createElement(Row, null,
                                            React.createElement(Col, { xs: 12, md: 4 },
                                                React.createElement(Controller, { control: control, name: "guarantors.".concat(index, ".titlesBefore"), render: function (_a) {
                                                        var field = _a.field;
                                                        return (React.createElement(RecekTextField, __assign({ labelId: "ui-br-publishers.publishers.guarantors.field.label.titlesBefore", disabled: lockedGuarantors[index] }, field, { autoComplete: "off" })));
                                                    } })),
                                            React.createElement(Col, { xs: 12, md: 4 },
                                                React.createElement(Controller, { control: control, name: "guarantors.".concat(index, ".firstName"), render: function (_a) {
                                                        var _b, _c, _d;
                                                        var field = _a.field;
                                                        return (React.createElement(RecekTextField, __assign({ labelId: "ui-br-publishers.publishers.guarantors.field.label.firstName" }, field, { autoComplete: "off", required: true, disabled: lockedGuarantors[index], error: (_d = (_c = (_b = errors.guarantors) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.firstName) === null || _d === void 0 ? void 0 : _d.message })));
                                                    } })),
                                            React.createElement(Col, { xs: 12, md: 4 },
                                                React.createElement(Controller, { control: control, name: "guarantors.".concat(index, ".lastName"), render: function (_a) {
                                                        var _b, _c, _d;
                                                        var field = _a.field;
                                                        return (React.createElement(RecekTextField, __assign({ labelId: "ui-br-publishers.publishers.guarantors.field.label.lastName" }, field, { autoComplete: "off", required: true, disabled: lockedGuarantors[index], error: (_d = (_c = (_b = errors.guarantors) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.lastName) === null || _d === void 0 ? void 0 : _d.message })));
                                                    } })),
                                            React.createElement(Col, { xs: 12, md: 4 },
                                                React.createElement(Controller, { control: control, name: "guarantors.".concat(index, ".titlesAfter"), render: function (_a) {
                                                        var field = _a.field;
                                                        return (React.createElement(RecekTextField, __assign({ labelId: "ui-br-publishers.publishers.guarantors.field.label.titlesAfter", disabled: lockedGuarantors[index] }, field, { autoComplete: "off" })));
                                                    } })),
                                            React.createElement(Col, { xs: 12, md: 4 },
                                                React.createElement(Controller, { control: control, name: "guarantors.".concat(index, ".email"), render: function (_a) {
                                                        var _b, _c, _d;
                                                        var field = _a.field;
                                                        return (React.createElement(RecekTextField, __assign({ labelId: "ui-br-publishers.publishers.guarantors.field.label.email" }, field, { autoComplete: "off", required: true, error: (_d = (_c = (_b = errors.guarantors) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.email) === null || _d === void 0 ? void 0 : _d.message, onChange: function (e) {
                                                                field.onChange(e);
                                                                unlockGuarantor(index);
                                                            }, onBlur: function () {
                                                                field.onBlur();
                                                                handleGuarantorEmailBlur(index);
                                                            } })));
                                                    } })),
                                            React.createElement(Col, { xs: 2 }, guarantorFields.length > 1 && (React.createElement(Button, { buttonStyle: "danger", onClick: function () { return removeGuarantorAtIndex(index); }, style: { marginTop: "25px" } },
                                                React.createElement(FormattedMessage, { id: "ui-br-publishers.publishers.guarantors.button.delete" })))),
                                            React.createElement(Col, { xs: 6 },
                                                React.createElement(Row, null,
                                                    React.createElement("h3", null,
                                                        React.createElement(FormattedMessage, { id: "ui-br-publishers.publishers.guarantors.role" }))),
                                                React.createElement(Controller, { control: control, name: "guarantors.".concat(index, ".roles"), render: function (_a) {
                                                        var _b, _c;
                                                        var _d = _a.field, _e = _d.value, value = _e === void 0 ? [] : _e, onChange = _d.onChange;
                                                        // one role per guarantor; a dual role shows as PublisherAdmin (DB-520)
                                                        var selected = resolveGuarantorRole(value);
                                                        var pick = function (role) {
                                                            onChange(toggleGuarantorRole(value, role, {
                                                                allowDeselect: true,
                                                            }));
                                                        };
                                                        return (React.createElement(React.Fragment, null,
                                                            React.createElement(Checkbox, { label: formatMessage({
                                                                    id: "ui-br-publishers.publishers.guarantors.role.publisherAdmin",
                                                                }), checked: selected === "PublisherAdmin", onChange: function () { return pick("PublisherAdmin"); }, 
                                                                // the create form never runs as "Můj nakladatel"; the role is preset and
                                                                // not editable here (the former MY_PUBLISHER check read window.status)
                                                                disabled: true }),
                                                            React.createElement(Checkbox, { label: formatMessage({
                                                                    id: "ui-br-publishers.publishers.guarantors.role.publisherGuarantor",
                                                                }), checked: selected === "PublisherGuarantor", onChange: function () { return pick("PublisherGuarantor"); }, 
                                                                // the create form never runs as "Můj nakladatel"; the role is preset and
                                                                // not editable here (the former MY_PUBLISHER check read window.status)
                                                                disabled: true }),
                                                            ((_c = (_b = errors.guarantors) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.roles) && (React.createElement("div", { style: {
                                                                    color: "#d00",
                                                                    marginTop: "0.5rem",
                                                                } }, formatMessage({
                                                                id: "ui-br-publishers.publishers.validation.guarantors.roles",
                                                            })))));
                                                    } })),
                                            React.createElement(Col, { xs: 12 },
                                                React.createElement(Row, null,
                                                    React.createElement("h3", null, formatMessage({
                                                        id: "ui-br-publishers.publishers.accordion.label.contacts",
                                                    }))), (_a = watch("guarantors.".concat(index, ".contacts"))) === null || _a === void 0 ? void 0 :
                                                _a.map(function (contact, contactIndex) { return (React.createElement(Row, { key: contactIndex, style: { marginBottom: "10px" } },
                                                    React.createElement(Col, { xs: 4 },
                                                        React.createElement(Controller, { control: control, name: "guarantors.".concat(index, ".contacts.").concat(contactIndex, ".type"), render: function (_a) {
                                                                var _b, _c, _d, _e, _f, _g, _h, _j;
                                                                var field = _a.field;
                                                                return (React.createElement(RecekSelect, __assign({ labelId: "ui-br-publishers.publishers.guarantors.contacts.select.label.type", error: typeof ((_e = (_d = (_c = (_b = errors.guarantors) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.contacts) === null || _d === void 0 ? void 0 : _d[contactIndex]) === null || _e === void 0 ? void 0 : _e.type) ===
                                                                        "object"
                                                                        ? (_j = (_h = (_g = (_f = errors.guarantors) === null || _f === void 0 ? void 0 : _f[index]) === null || _g === void 0 ? void 0 : _g.contacts) === null || _h === void 0 ? void 0 : _h[contactIndex]) === null || _j === void 0 ? void 0 : _j.type.message
                                                                        : undefined }, field, { autoComplete: "off", dataOptions: [
                                                                        {
                                                                            value: "",
                                                                            label: formatMessage({
                                                                                id: "ui-br-publishers.publishers.contacts.select.label.default",
                                                                            }),
                                                                        },
                                                                        {
                                                                            value: "EMAIL",
                                                                            label: formatMessage({
                                                                                id: "ui-br-publishers.publishers.guarantors.contacts.select.label.email",
                                                                            }),
                                                                        },
                                                                        {
                                                                            value: "WEB",
                                                                            label: formatMessage({
                                                                                id: "ui-br-publishers.publishers.guarantors.contacts.select.label.web",
                                                                            }),
                                                                        },
                                                                        {
                                                                            value: "PHONE",
                                                                            label: formatMessage({
                                                                                id: "ui-br-publishers.publishers.guarantors.contacts.select.label.phone",
                                                                            }),
                                                                        },
                                                                        {
                                                                            value: "DATA_BOX",
                                                                            label: formatMessage({
                                                                                id: "ui-br-publishers.publishers.guarantors.contacts.select.label.dataBox",
                                                                            }),
                                                                        },
                                                                    ] })));
                                                            } })),
                                                    React.createElement(Col, { xs: 4 },
                                                        React.createElement(Controller, { control: control, name: "guarantors.".concat(index, ".contacts.").concat(contactIndex, ".value"), render: function (_a) {
                                                                var _b, _c, _d, _e, _f;
                                                                var field = _a.field;
                                                                return (React.createElement(RecekTextField, __assign({ labelId: "ui-br-publishers.publishers.contacts.field.label.contact", error: (_f = (_e = (_d = (_c = (_b = errors.guarantors) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.contacts) === null || _d === void 0 ? void 0 : _d[contactIndex]) === null || _e === void 0 ? void 0 : _e.value) === null || _f === void 0 ? void 0 : _f.message }, field, { autoComplete: "off" })));
                                                            } })),
                                                    React.createElement(Col, { xs: 4 },
                                                        React.createElement(Controller, { control: control, name: "guarantors.".concat(index, ".contacts.").concat(contactIndex, ".info"), render: function (_a) {
                                                                var field = _a.field;
                                                                return (React.createElement(RecekTextField, __assign({ labelId: "ui-br-publishers.publishers.contacts.field.label.info" }, field, { autoComplete: "off" })));
                                                            } })),
                                                    React.createElement(Col, { xs: 2 },
                                                        React.createElement(Button, { buttonStyle: "danger", onClick: function () {
                                                                var currentContacts = getValues("guarantors.".concat(index, ".contacts")) || [];
                                                                var updatedContacts = currentContacts.filter(function (_, i) { return i !== contactIndex; });
                                                                setValue("guarantors.".concat(index, ".contacts"), updatedContacts);
                                                            }, style: { marginTop: "25px" } },
                                                            React.createElement(FormattedMessage, { id: "ui-br-publishers.publishers.guarantors.contacts.button.delete" }))))); }),
                                                React.createElement(Button, { type: "button", onClick: function () {
                                                        var currentContacts = getValues("guarantors.".concat(index, ".contacts")) || [];
                                                        setValue("guarantors.".concat(index, ".contacts"), __spreadArray(__spreadArray([], currentContacts, true), [
                                                            { type: "", value: "", info: "" },
                                                        ], false));
                                                    } },
                                                    React.createElement(FormattedMessage, { id: "ui-br-publishers.publishers.guarantors.contacts.button.add" }))))));
                                }),
                                React.createElement(Button, { type: "button", onClick: function () {
                                        return appendGuarantor({
                                            id: "",
                                            firstName: "",
                                            lastName: "",
                                            email: "",
                                            contacts: [],
                                            user: {
                                                sourceId: "",
                                                firstName: "",
                                                lastName: "",
                                                email: "",
                                                roles: [],
                                            },
                                            roles: ["PublisherGuarantor"],
                                        });
                                    }, style: { marginTop: "20px" } },
                                    React.createElement(FormattedMessage, { id: "ui-br-publishers.publishers.guarantors.button.add" }))))),
                    watch("registrations.0.registrationIntent") === "ONE_OFF" && (React.createElement(Accordion, { label: formatMessage({
                            id: "ui-br-publishers.publishers.accordion.label.workSpec",
                        }), open: accordionStatus.workSpecification, onToggle: function () {
                            return setAccordionStatus(__assign(__assign({}, accordionStatus), { workSpecification: !accordionStatus.workSpecification }));
                        } },
                        React.createElement(Row, null,
                            React.createElement(Col, { xs: 12 },
                                React.createElement(Controller, { control: control, name: "workSpecification.title", render: function (_a) {
                                        var _b, _c;
                                        var field = _a.field;
                                        return (React.createElement(RecekTextField, __assign({}, field, { autoComplete: "off", labelId: "ui-br-publishers.publishers.workSpec.field.label.title", required: true, error: (_c = (_b = errors.workSpecification) === null || _b === void 0 ? void 0 : _b.title) === null || _c === void 0 ? void 0 : _c.message })));
                                    } }))),
                        React.createElement(Row, null,
                            React.createElement(Col, { xs: 12 },
                                React.createElement(Controller, { control: control, name: "workSpecification.subtitle", render: function (_a) {
                                        var _b, _c;
                                        var field = _a.field;
                                        return (React.createElement(RecekTextField, __assign({}, field, { autoComplete: "off", labelId: "ui-br-publishers.publishers.workSpec.field.label.subTitle", error: (_c = (_b = errors.workSpecification) === null || _b === void 0 ? void 0 : _b.subtitle) === null || _c === void 0 ? void 0 : _c.message })));
                                    } }))),
                        React.createElement(Row, null,
                            React.createElement(Col, { xs: 12 },
                                React.createElement(Controller, { control: control, name: "workSpecification.volumeNumber", render: function (_a) {
                                        var _b, _c;
                                        var field = _a.field;
                                        return (React.createElement(RecekTextField, __assign({}, field, { autoComplete: "off", labelId: "ui-br-publishers.publishers.workSpec.field.label.volumeNumber", error: (_c = (_b = errors.workSpecification) === null || _b === void 0 ? void 0 : _b.volumeNumber) === null || _c === void 0 ? void 0 : _c.message })));
                                    } }))),
                        React.createElement(Row, null,
                            React.createElement(Col, { xs: 12 },
                                React.createElement(Controller, { control: control, name: "workSpecification.partTitle", render: function (_a) {
                                        var _b, _c;
                                        var field = _a.field;
                                        return (React.createElement(RecekTextField, __assign({}, field, { autoComplete: "off", labelId: "ui-br-publishers.publishers.workSpec.field.label.partName", error: (_c = (_b = errors.workSpecification) === null || _b === void 0 ? void 0 : _b.partTitle) === null || _c === void 0 ? void 0 : _c.message })));
                                    } }))),
                        React.createElement(Row, null,
                            React.createElement(Col, { xs: 12 },
                                React.createElement("h3", null,
                                    React.createElement(FormattedMessage, { id: "ui-br-publishers.publishers.workSpec.title.authors" })))),
                        authorFields.map(function (author, index) { return (React.createElement(AuthorityAuthorRow, { key: author.id, author: watchedAuthors === null || watchedAuthors === void 0 ? void 0 : watchedAuthors[index], linkedPersonIds: personIdsLinkedElsewhere(watchedAuthors, index), searchAuthors: searchAuthors, onPick: function (picked) {
                                return setValue("workSpecification.authors.".concat(index), picked, {
                                    shouldValidate: true,
                                    shouldDirty: true,
                                });
                            }, onClear: function () {
                                return setValue("workSpecification.authors.".concat(index), unlinkedAuthor(), {
                                    shouldValidate: true,
                                    shouldDirty: true,
                                });
                            }, onRemove: function () { return removeAuthor(index); }, renderNameField: function (name, readOnly) { return (React.createElement(Controller, { control: control, name: "workSpecification.authors.".concat(index, ".").concat(name), render: function (_a) {
                                    var _b, _c, _d, _e;
                                    var field = _a.field;
                                    return (React.createElement(RecekTextField, __assign({}, field, { readOnly: readOnly, autoComplete: "off", labelId: "ui-br-publishers.publishers.workSpec.field.label.authors.".concat(name), error: (_e = (_d = (_c = (_b = errors.workSpecification) === null || _b === void 0 ? void 0 : _b.authors) === null || _c === void 0 ? void 0 : _c[index]) === null || _d === void 0 ? void 0 : _d[name]) === null || _e === void 0 ? void 0 : _e.message })));
                                } })); } })); }),
                        React.createElement(Row, null,
                            React.createElement(Col, { xs: 12 },
                                React.createElement(Button, { onClick: function () { return appendAuthor(unlinkedAuthor()); } },
                                    React.createElement(FormattedMessage, { id: "ui-br-publishers.publishers.workSpec.button.authors.add" })))),
                        React.createElement(Row, null,
                            React.createElement(Col, { xs: 6 },
                                React.createElement(Controller, { control: control, name: "workSpecification.publicationDate", render: function (_a) {
                                        var _b, _c;
                                        var field = _a.field;
                                        return (React.createElement(RecekTextField, __assign({}, field, { autoComplete: "off", labelId: "ui-br-publishers.publishers.workSpec.datePicker.label.publicationDate", error: (_c = (_b = errors.workSpecification) === null || _b === void 0 ? void 0 : _b.publicationDate) === null || _c === void 0 ? void 0 : _c.message, placeholder: "DD.MM.YYYY / MM.YYYY / YYYY" })));
                                    } })),
                            React.createElement(Col, { xs: 6 },
                                React.createElement(Controller, { control: control, name: "workSpecification.editionNumber", render: function (_a) {
                                        var _b, _c;
                                        var field = _a.field;
                                        return (React.createElement(RecekTextField, __assign({}, field, { autoComplete: "off", labelId: "ui-br-publishers.publishers.workSpec.field.label.releaseOrder", error: (_c = (_b = errors.workSpecification) === null || _b === void 0 ? void 0 : _b.editionNumber) === null || _c === void 0 ? void 0 : _c.message })));
                                    } }))),
                        React.createElement(Row, null,
                            React.createElement(Col, { xs: 12 },
                                React.createElement(Controller, { control: control, name: "workSpecification.coEditionWith", render: function (_a) {
                                        var _b, _c;
                                        var field = _a.field;
                                        return (React.createElement(RecekTextField, __assign({}, field, { autoComplete: "off", labelId: "ui-br-publishers.publishers.workSpec.field.label.publishedInConjunction", error: (_c = (_b = errors.workSpecification) === null || _b === void 0 ? void 0 : _b.coEditionWith) === null || _c === void 0 ? void 0 : _c.message })));
                                    } }))),
                        React.createElement(WorkSpecFormatFields, { workSpecification: watch("workSpecification"), errors: errors.workSpecification, onChange: applyWorkSpecFormatFields, otherFormats: React.createElement(React.Fragment, null,
                                React.createElement(Row, null,
                                    React.createElement(Col, { xs: 12 },
                                        React.createElement("h3", null,
                                            React.createElement(FormattedMessage, { id: "ui-br-publishers.publishers.workSpec.select.label.ebookFormats.other" })))),
                                otherFormatFields.map(function (formatField, index) { return (React.createElement(Row, { key: formatField.id },
                                    React.createElement(Col, { xs: 10 },
                                        React.createElement(Controller, { control: control, name: "workSpecification.otherFormats.".concat(index, ".format"), render: function (_a) {
                                                var _b, _c, _d, _e;
                                                var field = _a.field;
                                                return (React.createElement(RecekTextField, __assign({}, field, { autoComplete: "off", labelId: "ui-br-publishers.publishers.workSpec.select.label.ebookFormats.otherFormat", error: (_e = (_d = (_c = (_b = errors.workSpecification) === null || _b === void 0 ? void 0 : _b.otherFormats) === null || _c === void 0 ? void 0 : _c[index]) === null || _d === void 0 ? void 0 : _d.format) === null || _e === void 0 ? void 0 : _e.message })));
                                            } })),
                                    React.createElement(Col, { xs: 2 },
                                        React.createElement(Button, { buttonStyle: "danger", onClick: function () { return removeOtherFormat(index); }, style: { marginTop: "25px" } },
                                            React.createElement(FormattedMessage, { id: "ui-br-publishers.publishers.workSpec.button.delete" }))))); }),
                                React.createElement(Row, null,
                                    React.createElement(Col, { xs: 12 },
                                        React.createElement(Button, { onClick: function () {
                                                return appendOtherFormat({ format: "" }, { shouldFocus: false });
                                            } },
                                            React.createElement(FormattedMessage, { id: "ui-br-publishers.publishers.workSpec.button.ebookFormats.add" }))))) }))),
                    React.createElement(Accordion, { label: formatMessage({
                            id: "ui-br-publishers.publishers.accordion.label.comments",
                        }), open: accordionStatus.comments, onToggle: function () {
                            return setAccordionStatus(__assign(__assign({}, accordionStatus), { comments: !accordionStatus.comments }));
                        } },
                        React.createElement(RecekTextArea, __assign({ labelId: "ui-br-publishers.publishers.comments.textArea.label.internalComment" }, register("internalComment"), { autoComplete: "off", onChange: handleInputChange })))))),
        React.createElement(DuplicateDetailPane, { selectedDuplicatePublisher: selectedDuplicatePublisher, onClose: onClose })));
};
export default PublisherCreate;
